import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'motivate_report',
    label: 'MotivateReport',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
